export default __webpack_public_path__ + "static/media/fullscreen-exit.90c308ef.svg";